import React, { createContext, useState, useContext, useRef, useEffect } from 'react';

const HoverContext = createContext({});

export const HoverProvider = ({ children }) => {
  const [hoveredButtonId, setHoveredButtonId] = useState(null);
  const [isDraggingWord, setIsDraggingWord] = useState(false);
  const [draggedWordId, setDraggedWordId] = useState(false);

  const [draggedWordPosition, setDraggedWordPosition] = useState(null);
  const stageRef = useRef(null);

  const handleHoverEnter = (buttonId) => { 
    setHoveredButtonId(buttonId);
  };

const handleHoverLeave = () => {
      if (!isDraggingWord) { 
          setHoveredButtonId(null);
      }
};

  const handleWordDragStart = (draggingWordId) => {
    setDraggedWordId(draggingWordId);
    setIsDraggingWord(true);
  };

  const handleWordDragEnd = () => {
      setIsDraggingWord(false);  // Allow React to finish UI updates
      setDraggedWordId(null);
  };

  useEffect(() => {
    if (!isDraggingWord) {
        setHoveredButtonId(null);
    }
}, [isDraggingWord]);  // Runs whenever isDraggingWord changes

  return (
    <HoverContext.Provider
      value={{
        hoveredButtonId,
        handleHoverEnter,
        handleHoverLeave,
        isDraggingWord,
        handleWordDragStart,
        handleWordDragEnd,
        draggedWordPosition,
        setDraggedWordPosition,
        draggedWordId,
        setDraggedWordId,
        stageRef
      }}
    >
      {children}
    </HoverContext.Provider>
  );
};

export const useHover = () => useContext(HoverContext);
